import { useQuery } from '@tanstack/react-query';
import { fetchMyTeamSchedule } from '../api/teamScheduleApi';
import { monthRange } from '../lib/buildScheduleMonth';
import { teamScheduleKeys } from './teamScheduleKeys';

/** 보고 있는 달의 내 팀 일정 — 출퇴근 달력 칸의 마감 배지 · 몰림 테두리 · 팀 휴가자 */
export function useMyTeamSchedule(year: number, month: number, enabled = true) {
  const { from, to } = monthRange(year, month);
  return useQuery({
    queryKey: teamScheduleKeys.range(from, to),
    queryFn: () => fetchMyTeamSchedule({ from, to }),
    enabled,
    staleTime: 60_000,
  });
}
